import { Box, Button, Typography } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { EasTableWithFilter } from 'ui/EasTableWithFilter';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import { tableStructure } from './tableStructure';
import { EudrRegisterDialog } from './EudrRegisterDialog';
import { getEudrItems, getEudrItemsLoading } from '../../redux/reducers/eudr/selectors';
import { getEudrItemsRequest } from '../../redux/reducers/eudr/reducer';
import { ESortDirection, ETableStructureType } from '../../ui/EasTable/types';
import { PAGE_SIZE } from '../../services/constants/env';
import { DATES_ARRAY, DATES_ID } from '../../services/constants/dates-constants';
import { TFilters, TOrderBy } from '../../redux/types';
import { TEudrItem } from '../../redux/reducers/eudr/types';
import { saveUrl } from '../../redux/reducers/auth/reducer';
import { PATHS } from '../../routes/constants';
import { AddAttachmentDialog } from '../EMManagement/EMManagementId/EMManagementIdBody/EmAttachments/AddAttachmentDialog';

export const EUDR: FC = () => {
	const dispatch = useDispatch();
	const [openRegisterDialog, setOpenRegisterDialog] = useState(false);
	const [openAddAttachmentDialog, setOpenAddAttachmentDialog] = useState(false);
	const eudrItems = useSelector(getEudrItems);
	const eudrItemsLoading = useSelector(getEudrItemsLoading);
	const navigate = useNavigate();
	const { search } = useLocation();
	const navigateParams = queryString.parse(search);
	const { page } = queryString.parse(search);
	const navigateParamsWithoutPage = tableStructure.reduce((acc, item) => {
		if (!!navigateParams[item.selector] && item.type === ETableStructureType.DATE) {
			if (navigateParams[item.selector] === DATES_ID.CUSTOM_RANGE) {
				if (navigateParams[`${String(item.selector)}StartDate`]) {
					acc.push({
						fieldName: item.selector,
						value: navigateParams[`${String(item.selector)}StartDate`] as string,
						operator: '>=',
					});
				}
				if (navigateParams[`${String(item.selector)}EndDate`]) {
					acc.push({
						fieldName: item.selector,
						value: navigateParams[`${String(item.selector)}EndDate`] as string,
						operator: '<=',
					});
				}
				return acc;
			}
			const dates = DATES_ARRAY.find((i) => i.id === navigateParams[item.selector]);
			// console.log('dates', dates);
			if (dates?.from) {
				acc.push({
					fieldName: item.selector,
					value: dates.from,
					operator: '>=',
				});
			}
			if (dates?.to) {
				acc.push({
					fieldName: item.selector,
					value: dates.to,
					operator: '<=',
				});
			}
			return acc;
		}
		if (navigateParams[item.selector])
			acc.push({
				fieldName: item.selector,
				value: navigateParams[item.selector] as string,
				operator: '=',
			});
		return acc;
	}, [] as TFilters);

	useEffect(() => {
		const orderBy = [];
		if (navigateParams?.sortIndex) {
			orderBy.push({
				fieldName: navigateParams?.sortIndex
					? tableStructure[+navigateParams.sortIndex].selector
					: 'id',
				direction: navigateParams?.sortDirection
					? String(navigateParams.sortDirection) === 'desc'
						? ESortDirection.DESC
						: ESortDirection.ASC
					: ESortDirection.DESC,
			} as TOrderBy);
		}
		orderBy.push({
			fieldName: 'id',
			direction: ESortDirection.DESC,
		} as TOrderBy);
		dispatch(
			getEudrItemsRequest({
				pageNumber: page ? +page : 1,
				pageSize: PAGE_SIZE,
				searchString: String(navigateParams?.search ?? ''),
				filters: navigateParamsWithoutPage,
				orderBy,
			}),
		);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [dispatch, search]);

	const handleLink = (id: number) => {
		dispatch(saveUrl(window.location.pathname + window.location.search));
		navigate(`${PATHS.EUDR_PAGE}/${id}`);
	};

	const setCloseAddAttachmentDialog = () => {
		setOpenAddAttachmentDialog(false);
	};

	return (
		<Box sx={{ p: 2 }}>
			<EasTableWithFilter<TEudrItem>
				tableStructure={tableStructure}
				items={eudrItems}
				itemsIsLoading={eudrItemsLoading}
				handleAction={() => {}}
				handleLink={handleLink}
			>
				<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
					<Typography variant="body1" color="primary" fontWeight="bold">
						EUDR
					</Typography>
					<Button
						type="button"
						variant="contained"
						size="small"
						onClick={() => setOpenRegisterDialog(true)}
					>
						Add Customer
					</Button>
				</Box>
			</EasTableWithFilter>
			<EudrRegisterDialog open={openRegisterDialog} setClose={() => setOpenRegisterDialog(false)} />
		</Box>
	);
};
